import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getChannel, update as updateChannel} from "app/requests/admin/channels";
import {Loading} from "components/pages";
import {valueFrom, valueFromTarget} from "lib/form";
import {usePrompt} from "lib/hooks";
import useAppContext from "lib/hooks/use-app-context";
import Form from "./form";

export default function AdminChannelsEdit() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const {id} = useParams();
  const [block, setBlock] = useState(false);
  const [changes, setChanges] = useState({});
  const [channel, setChannel] = useState(null);

  usePrompt({when: block});
  useEffect(() => {
    getChannel(id).then((data) => setChannel(data.channel));
  }, []);

  if(!channel) { return <Loading />; }

  const onChange = ({target}) => {
    setBlock(true);
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (files) => {
    const updates = {...changes, ...files};

    if(Object.keys(updates).length === 0) {
      return dispatch(createNotification({
        content: "Please make changes before submitting",
        type: "danger"
      }));
    }

    setBlock(false);
    updateChannel(channel.id, {channel: updates}).then((data) => {
      if(data.success) {
        navigate("/admin/channels", {state: {message: data.message, type: "success"}});
      } else {
        dispatch(createNotification({content: data.message, type: "danger"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({
    defaultValue,
    name,
    objects: [changes, channel]
  });

  return (
    <div className="container-fluid">
      <h1 className="text-center">Edit Channel</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
